import { CheckoutState } from '../state';
import { isIosWebView, isSafari, isSocialWebView } from '../utils/browser';
import { isEventbriteTLD } from './app';

export const getGooglePayInstance = (state: CheckoutState) =>
    state.googlePay.googlePayInstance;

export const getGooglePayPaymentRequest = (state: CheckoutState) =>
    state.googlePay.googlePayPaymentRequest;

export const hasErrorInGooglePay = (state: CheckoutState) =>
    state.googlePay.hasError;

const getCanMakePaymentsWithGooglePay = (state: CheckoutState) =>
    !!state.googlePay.canMakePaymentsWithGooglePay;

export const isGooglePayAvailable = (state: CheckoutState) => {
    return (
        getCanMakePaymentsWithGooglePay(state) &&
        isEventbriteTLD(state) &&
        !isIosWebView() &&
        !isSocialWebView() &&
        !isSafari()
    );
};
